/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import Toolbar from 'loracoms/Toolbar';
import chplanActions from 'loraactions/chplan';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ChannelPlanBrief from './coms/ChannelPlanBrief';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  channelPlans: React.PropTypes.object.isRequired,
  getChannelPlans: React.PropTypes.func.isRequired,
  pushState: React.PropTypes.func.isRequired,
};

class ChannelPlans extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      channelPlans: props.channelPlans,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.bandview');
  }

  componentWillMount() {
    const { getChannelPlans } = this.props;
    getChannelPlans();
  }

  componentWillReceiveProps(nextProps) {
    const { channelPlans } = nextProps;
    if (channelPlans !== this.props.channelPlans) {
      this.setState({ channelPlans });
    }
  }

  renderToolbar() {
    const { pushState } = this.props;
    const addBtn = (
      <Button bsStyle="aisz-success" onClick={() => pushState('/network/chplans/add')}>
        {this.intlMsg.msg('addplan')}
        {' '}
        <span className="halflings halflings-plus" />
      </Button>
    );
    return (
      <Toolbar
        brandTitle={this.intlMsg.msg('title')}
        rightTools={[{ input: addBtn }]}
      />
    );
  }


  render() {
    const { channelPlans } = this.state;

    let list = [];
    if (channelPlans.status === 'success') {
      list = channelPlans.data.list;
    }

    const plans = list.map(p => <ChannelPlanBrief key={p.id} plan={p} />);

    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <div>
          {plans}
        </div>
      </Grid>
    );
  }
}

ChannelPlans.propTypes = propTypes;

const mapStateToProps = state => ({
  channelPlans: state.chplan.getChannelPlans,
});

const mapDispatchToProps = {
  getChannelPlans: chplanActions.getChannelPlans,
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ChannelPlans));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/ChannelView/coms/ChannelPlans/index.jsx